import React from 'react';
import useTitle from '../../hooks/useTitle';
import {PaginatedAccountsPage} from './PaginatedAccounts';
import {AlphabeticalAccountsWidget} from './AlphabeticalAccounts';
import {GlobalPermissionEnum} from '../../schema-types/globalTypes';
import {FeatureBoundary} from '../../contexts/FeatureBoundary';

const Dashboard: React.FC = () => {
  useTitle('Home');

  return (
    <>
      <FeatureBoundary
        features={[GlobalPermissionEnum.can_access_paginated_accounts_dashboard_FE]}
        showErrorIfDenied={false}
      >
        <PaginatedAccountsPage />
      </FeatureBoundary>
      <FeatureBoundary
        features={[GlobalPermissionEnum.can_access_alphabetical_accounts_dashboard_FE]}
        showErrorIfDenied={false}
      >
        <AlphabeticalAccountsWidget />
      </FeatureBoundary>
    </>
  );
};

export default Dashboard;
